var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIconRound3X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Devices---customer-supplied",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Devices_claiming_error_partial",
    transform: "translate(-810 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toast_error_partial",
    transform: "translate(781 167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toast_error_icon",
    transform: "translate(29 21)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-14-Copy-14",
    fill: "#EF4267",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.908 44.072c-2.158 0-3.908-1.714-3.908-3.828s1.75-3.828 3.908-3.828c2.159 0 3.908 1.714 3.908 3.828s-1.75 3.828-3.908 3.828zm4.09-24.065s.238 13.268-3.99 13.268c-4.227 0-3.989-13.268-3.989-13.268C25.943 17.8 27.72 16 29.937 16h.143c2.22 0 3.97 1.794 3.918 4.007z",
    id: "error_icon",
    fill: "#FFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconRound3X);
export default __webpack_public_path__ + "static/media/error_icon_round@3x.d4623fa34459deb53369bbd4ec4154c1.svg";
export { ForwardRef as ReactComponent };